import { getApiInstance, getOAuthToken } from './ApiToken'

export default {
  async settlement (params) {
    console.log('PARAMS>>' + JSON.stringify(params))
    const api = await getApiInstance()
    try {
      const response = await api.post('settlement', params)
      // console.log('RESPONSE SERVICE>>' + JSON.stringify(response))
      return response.data
    } catch (error) {
      if (error.response) {
        console.log('ERROR RESPONSE>>' + JSON.stringify(error.response))
        console.log('ERROR RESPONSE STATUS>>' + JSON.stringify(error.response.status))
        if (error.response.status === 401) {
          await getOAuthToken()
          const api = await getApiInstance()
          try {
            const response = await api.post('settlement', params)
            console.log('RESPONSE SERVICE AFTER REAUTH>>' + JSON.stringify(response))
            return response.data
          } catch (retryError) {
            if (retryError.response) {
              console.log('RETRY ERROR RESPONSE>>' + JSON.stringify(retryError.response))
              return {
                status: retryError.response.status,
                errors: retryError.response.data
              }
            }
            throw retryError
          }
        } else if (error.response.status === 422) {
          return {
            status: error.response.status,
            errors: error.response.data
          }
        }
      }
      throw error
    }
  },
  /* **** MGP **** */
  async settlementMGP (params) {
    console.log('PARAMS>>' + JSON.stringify(params))
    const api = await getApiInstance()
    try {
      const response = await api.post('settlement/mgp', params)
      // console.log('RESPONSE SERVICE>>' + JSON.stringify(response))
      return response.data
    } catch (error) {
      if (error.response) {
        console.log('ERROR RESPONSE>>' + JSON.stringify(error.response))
        console.log('ERROR RESPONSE STATUS>>' + JSON.stringify(error.response.status))
        if (error.response.status === 401) {
          await getOAuthToken()
          const api = await getApiInstance()
          try {
            const response = await api.post('settlement/mgp', params)
            console.log('RESPONSE SERVICE AFTER REAUTH>>' + JSON.stringify(response))
            return response.data
          } catch (retryError) {
            if (retryError.response) {
              console.log('RETRY ERROR RESPONSE>>' + JSON.stringify(retryError.response))
              return {
                status: retryError.response.status,
                errors: retryError.response.data
              }
            }
            throw retryError
          }
        } else if (error.response.status === 422) {
          return {
            status: error.response.status,
            errors: error.response.data.errors
          }
        }
      }
      throw error
    }
  },
  async settlementMGPXml (year, month) {
    console.log(`Fetching MGP XML for year: ${year}, month: ${month}`)
    const api = await getApiInstance()
    try {
      const response = await api.get(`settlement/mgp/xml/${year}/${month}`)
      console.log('RESPONSE SERVICE>>' + JSON.stringify(response))
      return response.data
    } catch (error) {
      if (error.response) {
        console.log('ERROR RESPONSE>>' + JSON.stringify(error.response))
        console.log('ERROR RESPONSE STATUS>>' + JSON.stringify(error.response.status))
        if (error.response.status === 404) {
          return {
            status: error.response.status,
            errors: 'Not Found'
          }
        }
      }
      throw error
    }
  },
  async sendMgpXmlToGme (params) {
    console.log('PARAMS>>' + JSON.stringify(params))
    const api = await getApiInstance()
    try {
      const response = await api.post('settlement/mgp/send-xml-gme', params)
      console.log('RESPONSE SERVICE>>' + JSON.stringify(response))
      return response
    } catch (error) {
      if (error.response) {
        console.log('ERROR RESPONSE>>' + JSON.stringify(error.response))
        console.log('ERROR RESPONSE STATUS>>' + JSON.stringify(error.response.status))
        if (error.response.status === 404) {
          return {
            status: error.response.status,
            errors: 'XML non trovato'
          }
        } else if (error.response.status === 409) {
          return {
            status: error.response.status,
            errors: 'XML già inviato'
          }
        }
        throw error
      }
    }
  },
  /* **** MTF **** */
  async settlementMtf (params) {
    console.log('PARAMS>>' + JSON.stringify(params))
    const api = await getApiInstance()
    try {
      const response = await api.post('settlement/mtf', params)
      return response.data
    } catch (error) {
      if (error.response) {
        console.log('ERROR RESPONSE>>' + JSON.stringify(error.response))
        console.log('ERROR RESPONSE STATUS>>' + JSON.stringify(error.response.status))
        if (error.response.status === 401) {
          await getOAuthToken()
          const api = await getApiInstance()
          try {
            const response = await api.post('settlement/mtf', params)
            console.log('RESPONSE SERVICE AFTER REAUTH>>' + JSON.stringify(response))
            return response.data
          } catch (retryError) {
            if (retryError.response) {
              console.log('RETRY ERROR RESPONSE>>' + JSON.stringify(retryError.response))
              return {
                status: retryError.response.status,
                errors: retryError.response.data
              }
            }
            throw retryError
          }
        } else if (error.response.status === 422) {
          return {
            status: error.response.status,
            errors: error.response.data.errors
          }
        }
      }
      throw error
    }
  },
  async settlementMtfXml (year, month) {
    console.log(`Fetching MGP XML for year: ${year}, month: ${month}`)
    const api = await getApiInstance()
    try {
      const response = await api.get(`settlement/mtf/xml/${year}/${month}`)
      return response.data
    } catch (error) {
      if (error.response) {
        console.log('ERROR RESPONSE>>' + JSON.stringify(error.response))
        console.log('ERROR RESPONSE STATUS>>' + JSON.stringify(error.response.status))
        if (error.response.status === 404) {
          return {
            status: error.response.status,
            errors: 'Not Found'
          }
        }
      }
      throw error
    }
  },
  async sendMtfXmlToGme (params) {
    console.log('PARAMS>>' + JSON.stringify(params))
    const api = await getApiInstance()
    try {
      const response = await api.post('settlement/mtf/send-xml-gme', params)
      console.log('RESPONSE SERVICE>>' + JSON.stringify(response))
      return response
    } catch (error) {
      if (error.response) {
        console.log('ERROR RESPONSE>>' + JSON.stringify(error.response))
        console.log('ERROR RESPONSE STATUS>>' + JSON.stringify(error.response.status))
        if (error.response.status === 404) {
          return {
            status: error.response.status,
            errors: 'XML non trovato'
          }
        } else if (error.response.status === 409) {
          return {
            status: error.response.status,
            errors: 'XML già inviato'
          }
        }
        throw error
      }
    }
  },
  async retrieveMeasures (params) {
    console.log('PARAMS>>' + JSON.stringify(params))
    const api = await getApiInstance()
    const body = {
      pod: params.pod,
      flowDate: params.flowDate
    }
    try {
      const response = await api.put('settlement/measures', body)
      // const response = await api.get('settlement/measures', { params })
      return response
    } catch (error) {
      if (error.response) {
        console.log('ERROR RESPONSE>>' + JSON.stringify(error.response))
        console.log('ERROR RESPONSE STATUS>>' + JSON.stringify(error.response.status))
        if (error.response.status === 404) {
          console.log('RETRY ERROR RESPONSE>>' + JSON.stringify(error.response))
          return {
            status: error.response.status,
            errors: error.response.data
          }
        }
        if (error.response.status === 401) {
          await getOAuthToken()
          const api = await getApiInstance()
          try {
            const response = await api.get('settlement/measures', { params })
            console.log('RESPONSE SERVICE AFTER REAUTH>>' + JSON.stringify(response))
            return response.data
          } catch (retryError) {
            if (retryError.response) {
              console.log('RETRY ERROR RESPONSE>>' + JSON.stringify(retryError.response))
              return {
                status: retryError.response.status,
                errors: retryError.response.data
              }
            }
            throw retryError
          }
        }
        if (error.response.status === 422) {
          console.log('RETRY ERROR RESPONSE>>' + JSON.stringify(error.response))
          return {
            status: error.response.status,
            errors: error.response.data
          }
        }
      }
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/SettlementService.js